var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SectionBlock",
    [
      !_vm.store.crossType ? _c("DefaultAlgorithmSettingField") : _vm._e(),
      _c("AlgorithmField"),
      _vm.store.algorithmOption && _vm.store.algorithmOption.children.matrix
        ? _c("ScoringMatrixField")
        : _vm._e(),
      _vm.store.algorithmOption && _vm.store.algorithmOption.children.word_size
        ? _c("WordSizeField")
        : _vm._e(),
      _vm.store.algorithmOption &&
      _vm.store.algorithmOption.children.match_scores
        ? _c("MatchScoresField")
        : _vm._e(),
      _c("GapCostsField"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }